module.exports = __webpack_public_path__ + "img/bg-login.92ee0183.png";